import React from 'react'

const VisualSearch = () => {
  return (
    <div>
      hello search
    </div>
  )
}

export default VisualSearch
